module.exports = __webpack_public_path__ + "static/media/login_pic.39f0e742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_pic.png
// module id = 3234
// module chunks = 0